import Vue from 'vue'
import App from './App.vue'
import connect from '@vkontakte/vkui-connect'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

connect.send('VKWebAppInit');
 
// Подписывается на события, отправленные клиентом
connect.subscribe((e) => HandlerVK(e));
connect.send("VKWebAppGetUserInfo", {});

function HandlerVK(item) {
  switch(item.detail.type) {
    case 'VKWebAppGetUserInfoResult':
    localStorage.user = JSON.stringify(item.detail.data)
    break;
    default:
    console.log(item)
    break;
  }
}
